







































































































































import { Vue, Component } from "vue-property-decorator";
import Address from "@/zh-website/src/components/website/Address.vue";
import UploadFile from "./uploadFile.vue";
import {
  validateForm,
  validateRequired,
  validateAddress,
  validateInt,
  validatePosNumber,
  validateAlphanumeric,
  validateWeb
} from "./validate.js";

@Component({
  components: {
    Address,
    UploadFile
  }
})
export default class RegisterStepOne extends Vue {

  //status 1 已完成 2 进行中 3未完成
  stepList = [
    {
      step: 1,
      text: "选择业务范围",
      status: 1
    },
    {
      step: 2,
      text: "填写公司基本信息",
      status: 2
    },
    {
      step: 3,
      text: "填写公司经营信息",
      status: 3
    },
    {
      step: 4,
      text: "填写业务联系人信息",
      status: 3
    },
    {
      step: 5,
      text: "完成登记",
      status: 3
    }
  ];
  dataList = [
    {
      data: "",
      label: "参投项目名称",
      placeholder: "请完整输入本次参投的项目名称，如无明确项目请填写无",
      warn: "请输入参投项目名称",
      require: true,
      name: "projectName",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "主营业务",
      placeholder: "请完整输入主营业务",
      warn: "请输入主营业务",
      require: true,
      name: "pending",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "公司注册名称",
      placeholder: "请输入完整的公司全称",
      warn: "请输入公司全称",
      require: true,
      name: "companyName",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "公司英文名称",
      placeholder: "如涉及，请填写",
      warn: "",
      require: false,
      name: "companyNameEn",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "公司网址",
      placeholder: "如涉及，请填写（请输入完整域名：https://www.example.com）",
      warn: "",
      require: false,
      name: "website",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateWeb
    },
    {
      data: "",
      label: "公司成立时间",
      placeholder: "请选择公司成立时间",
      warn: "请选择公司成立时间",
      require: true,
      name: "establishmentTime",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: {
        province: "",
        city: "",
        district: "",
        detail: ""
      },
      label: "公司注册地址",
      placeholder: "请输入详细地址",
      warn: "请输入公司注册地址",
      require: true,
      name: "registeredAddress",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateAddress
    },
    {
      data: {
        province: "",
        city: "",
        district: "",
        detail: ""
      },
      label: "公司办公地址",
      placeholder: "请输入详细地址",
      warn: "请输入公司办公地址",
      require: true,
      name: "officeAddress",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateAddress
    },
    {
      data: {
        province: "",
        city: "",
        district: "",
        detail: ""
      },
      label: "公司生产地址",
      placeholder: "请输入详细地址",
      warn: "请输入公司生产地址",
      require: false,
      name: "productionAddress",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateAddress
    },
    {
      data: {
        province: "",
        city: "",
        district: "",
        detail: ""
      },
      label: "公司研发地址",
      placeholder: "请输入详细地址",
      warn: "请输入公司研发地址",
      require: false,
      name: "researchAddress",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateAddress
    },
    {
      data: "",
      label: "营业执照号",
      placeholder: "请输入营业执照号",
      warn: "请输入营业执照号",
      require: true,
      name: "businessLicense",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateAlphanumeric
    },
    {
      data: "",
      label: "营业执照",
      placeholder: "多个文件请打包上传,文件限制20M,支持PDF、WORD、ZIP等格式",
      warn: "请上传营业执照",
      require: true,
      name: "businessLicenseAnnex",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "是否上市",
      placeholder: "",
      warn: "请选择是否上市",
      require: true,
      name: "listFlag",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "上市所在地",
      placeholder: "如是，请填写所在地区",
      warn: "",
      require: false,
      name: "listAddress",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "注册资金",
      placeholder: "请输入公司注册资金",
      warn: "请输入公司注册资金",
      require: true,
      name: "registrationAmount",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validatePosNumber
    },
    {
      data: "",
      label: "注册资金币种",
      placeholder: "",
      warn: "请选择注册资金币种",
      require: true,
      name: "currency",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "公司总人数",
      placeholder: "请输入公司总人数，如1000",
      warn: "请输入公司总人数",
      require: true,
      name: "peopleNum",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateInt
    },
    {
      data: "",
      label: "法人代表",
      placeholder: "请输入法人代表姓名",
      warn: "请输入法人代表姓名",
      require: true,
      name: "legalPerson",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "公司简介",
      placeholder: "请输入公司简介",
      warn: "请输入公司简介",
      require: true,
      name: "companyProfile",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    },
    {
      data: "",
      label: "",
      placeholder: "多个文件请打包上传,文件限制20M,支持PDF、WORD、ZIP等格式",
      warn: "请上传附件",
      require: true,
      name: "companyAnnex",
      errMessage: {
        show: false,
        text: ""
      },
      validate: validateRequired
    }
  ];
  options = [
    {
      value: 1,
      label: "是"
    },
    {
      value: 0,
      label: "否"
    }
  ];
  optionsM = [
    {
      value: "CNY",
      label: "CNY"
    },
    {
      value: "USD",
      label: "USD"
    }
  ];
  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storage
  }
  onStep(step: number) {
    const result = validateForm(this.dataList);
    !result && this.$emit("onStep", step, this.dataList);
  }
}
